export const SHOW_PARAMS = [ "revenue", "spend", "roi", "factor" ];


// WEBPACK FOOTER //
// ./src/scenes/DynamicHourlyCutoff/config.js